import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BILightGrey } from "../../assets/helpers";
import { FETCH_TUTORIAL_VIDEOS } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { VPlayer } from "../videos/VPlayer";
import { VideoDetails } from "../videos/VideoDetails";
import { VideosList } from "../videos/VideosList";

export const TutorialViewVideosModal = ({ isOpen, onClose, data, appId }) => {
  const { loginData, selectedClientData } = useSelector((state) => state?.main);
  const [loading, setLoading] = useState(false);
  const [videosList, setVideosList] = useState([]);
  const [currentVideo, setCurrentVideo] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setCurrentVideo(data);
      fetchVideos(data);
    }
  }, [isOpen, data]);

  const fetchVideos = async (activeVideo = data) => {
    setLoading(true);
    const searchObj = {
      PageNr: 1,
      NrOfRecPerPage: 20,
      FullSearch: "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: true,
      TypeOfObjectReturned: "",
      SortList: [{ FieldName: "Id", Direction: "desc" }],
       SearchList: [
         {
           ...(appId && { AppId: appId }),
           appScreenId: 2,
           Deleted: false,
           isVisible: true,
           visibilityScope: data?.visibilityScope
         }
       ]
    };

    try {
      const res = await Postrequestcall(FETCH_TUTORIAL_VIDEOS, searchObj, loginData?.accessToken);
      if (res?.status === 200) {
        const filteredVideos = (res?.data?.data || []).filter((video) => video?.id !== activeVideo?.id);
        setVideosList(filteredVideos);
      }
    } catch (error) {
      console.error("Error fetching tutorial videos:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleVideoSelect = (video) => {
    setCurrentVideo(video);
    fetchVideos(video);
  };

  const currentVideoSource = currentVideo?.fileUrl || currentVideo?.fileName;

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="client-modal-responsive" style={{ height: "94vh", overflow: "scroll" }}>
        <div className="action-button-container">
          <div />
          <IconButton
            size="small"
            onClick={onClose}
            sx={{
              color: selectedClientData?.AccentColor || BILightGrey
            }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        <div style={{ borderRadius: "10px", overflow: "hidden" }}>
          <VPlayer
            isVisible={isOpen}
            source={{
              src: currentVideoSource,
              type: "application/x-mpegURL"
            }}
          />
        </div>

        <VideoDetails video={currentVideo} />

        <VideosList
          videos={videosList}
          onVideoSelect={handleVideoSelect}
          loading={loading}
        />
      </div>
    </Modal>
  );
};
